<template>
    <div class="page newpage">
        <div class="_flex_sb">
            <div class="w_40">
                <div class="calendar">
                    <div class="today-date-text">
                        <div class="today-date">{{currentDateText}}</div>
                        <el-button-group>
                            <el-button size="small" icon="el-icon-arrow-left" @click="toLastMonth">上个月</el-button>
                            <el-button size="small" @click="toNextMonth">下个月<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                        </el-button-group>
                    </div>
                    <div class="week-wrapper">
                        <div class="week-item">周日</div>
                        <div class="week-item">周一</div>
                        <div class="week-item">周二</div>
                        <div class="week-item">周三</div>
                        <div class="week-item">周四</div>
                        <div class="week-item">周五</div>
                        <div class="week-item">周六</div>
                    </div>
                    <div class="month-day-wrapper">
                        <div v-for="day in days" :class="day.selected ? 'day-item-actived' : 'day-item'" @click="handleDay(day)" style="display: flex;justify-content: center;align-items: center;">
                            <div>
                                <div class="date-text">{{day.isToday ? '今天' : day.dateText}}</div>
                                <div class="chinese-date-text">{{day.chineseDateText}}</div>
                            </div>
                            <div style="width: 10px;height: 10px;border-radius: 50%;background-color: #ffa51e;" v-if="day.dateText && day.state == 1"></div>
                            <div style="width: 10px;height: 10px;border-radius: 50%;background-color: #b9b9b9;" v-if="day.dateText  && day.state == 2"></div>
                        </div>
                        <div class="day-item" v-for="item in (7 - days.length % 7)"></div>
                    </div>
                </div>
                <div style="display: flex;align-items: center;justify-content: space-around;">
					<div style="display: flex;align-items: center;">
						<div style="width: 10px;height: 10px;border-radius: 50%;background-color: #ffa51e;"></div>
						<div style="margin-left: 10px;">有未完成事项</div>
                        <div style="color: red;margin-left: 10px;">{{unfinish}}</div>
					</div>
					<div style="display: flex;align-items: center;">
						<div style="width: 10px;height: 10px;border-radius: 50%;background-color: #b9b9b9;"></div>
						<div style="margin-left: 10px;">事项已完成</div>
					</div>
                    <el-button type="primary" icon="el-icon-plus" circle @click="open"></el-button>
				</div>
            </div>
            <div class="w_60 ml_60">
                <div class="f_18 mb_30">事项明细</div>
                <div class="br_10 mb_20 unselected" :class="{selected: selectedId == item.todo_id}" v-for="item in dayLists" :key="item.todo_id">
                    <div class="_flex _f_ai p_20" @click="selectedId = item.todo_id">
                        <div class="ml_10 mr_10">
                            <el-checkbox v-model="item.state" :true-label="2" :false-label="1" @change="change(item)" style="transform: scale(1.3);"></el-checkbox>
                        </div>
                        <div class="mr_20">{{item.todo_time}}</div>
                        <div style="flex: 1 0 0;">
                            <div>{{item.todo_content}}</div>
                            <div style="color: #999;margin-top: 6px;">{{item.todo_remark}}</div>
                        </div>
                        <a class="el-icon-delete red f_20" @click="del(item)"></a>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="待办事项" :visible="show" width="500px" center @close="show=false">
            <el-form label-position="right" label-width="80px" :model="formData" class="pr_20">
                <el-form-item label="时间：">
                    <el-date-picker v-model="formData.todo_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" class="w200" placeholder="" />
                </el-form-item>
                <el-form-item label="事项：">
                    <el-input v-model="formData.todo_content" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="formData.todo_remark" placeholder="请输入"></el-input>
                </el-form-item>
                <!-- <el-form-item label="附件：">
                    <span class="bag_e p_5 br_6">设计很高.png<a class="el-icon-delete c7 ml_10"></a></span>
                    <a class="el-icon-upload2 f_20 ml_10"></a>
                    <a class="el-icon-download blue f_20 ml_10"></a>
                </el-form-item> -->
            </el-form>
            <span slot="footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="add">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { toLunar } from '@/util/lunar.js'
import { todoLists, todoAdd, todoEdit, todoFinish, todoDel } from "@/request/apis.js"
export default {
    data() {
        return {
            month: '',
            day: '',
            calendarValue: new Date(),
            elCalendar: null,

            list: [],
            group: [],
            dayLists: [],
            selectedId: '',
            show: false,
            formDataInit: {},
            formData : {
                type: 0,
                todo_content: '',
                todo_time: '',
                todo_remark: '',
                name :''
            },
            unfinish: 0,
            days: [], // 当前月的所有日期的数据集合
            currentDateText: '', // 头部标题年月
            currentDate: '', // 初始化时为当前日期
        };
    },
    mounted() {
        this.formDataInit = {...this.formData};
        this.elCalendar = this.$refs.elCalendarRef;
        this.initPicker();
    },
    methods: {
        initPicker(y, m, d) {
            this.currentDate = new Date()
            if(y && m && d){
                this.currentDate = new Date(y, m, d)
            }
            this.currentDateText = this.getDateText(this.currentDate);
            this.days = this.getPickerData(this.currentDate);
            this.month = this.getMonth(this.currentDate);
            this.todoLists();
        },
        toLastMonth() {
            this.initPicker(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1);
            this.dayLists = [];
        },
        toNextMonth() {
            this.initPicker(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 1);
            this.dayLists = [];
        },
        async todoLists(){
            var res = await todoLists({month: this.month});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }

            this.days.forEach(day => {
                if(day.dateText){
                    day.state = 0;
                    day.todo = [];
                    res.data.forEach(todo => {
                        if(todo.todo_time.startsWith(day.fullday)){
                            day.todo.push(todo);
                            day.state = 2;
                            if(todo.state == 1){
                                day.state = 1;
                            }
                        }
                    });
                    if(day.selected){
                        this.dayLists = day.todo;
                    }
                }
            });
            this.unfinish = res.other.unfinish || 0;
            this.$forceUpdate();
        },
        open(){
            this.formData = {...this.formDataInit};
            this.show = true;
        },
        async add(){
            var res = await todoAdd(this.formData);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.show = false;
            this.todoLists();
        },
        async del(row){
            var res = await todoDel({todo_id: row.todo_id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.todoLists();
        },
        async change(row){
            console.log('change', row.todo_id);
            var res = await todoFinish({todo_id: row.todo_id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.todoLists();
        },

        /////// 日历相关方法
        getSelectedDay() {
            for (var i = 0; i < this.days.length; i++) {
                if (this.days[i].selected) return this.days[i]
            }
        },
        /**
         * 日历点击事件,更新点击选中状态
         * @param {Object} day
         */
        handleDay(day) {
            if (!day.date) return
            for (var i = 0; i < this.days.length; i++) {
                this.days[i].selected = day.dateText === this.days[i].dateText
            }
            this.updateTitle(day);
            this.dayLists = day.todo;
            this.day = day.fullday;
        },
        /**
         * 更新标题年月
         * @param {Object} day
         */
        updateTitle(day) {
            this.currentDateText = this.getDateText(day.date)
        },
        
        /**
         * 设置日历标题
         * @param {Object} day
         */
        getDateText(day) {
            return day.getFullYear() + '年' + (day.getMonth() + 1) + '月'
        },
        getMonth(day) {
            return day.getFullYear() + '-' + (day.getMonth() + 1).toString().padStart(2, '0')
        },
        /**
         * 转换成周几
         * @param {Object} day
         */
        getWeekText(day) {
            let weekVal = day.getDay()
            let weekMap = { 0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六' };
            return '周' + weekMap[weekVal];
        },
        /**
         * 计算某个月的天数
         * @param {Object} month
         */
        getMonthDaysLength(day, month) {
            day.setMonth(month)
            day.setDate(0)
            return day.getDate()
        },
        /**
         * 根据日期对象计算当前月份1日为星期几,
         * 从而计算日期数组开始需要添加几个空数据
         * @param {Object} day
         */
        getEmptyDays(day) {
            return new Date(day.setDate(1)).getDay()
        },
        /**
         * 根据传入的day对象获取当前月的所有日期数据
         * @param {Object} day
         */
        getPickerData(day) {
            let arr = []
            let emptyLength = this.getEmptyDays(day)
            for (var i = 0; i < emptyLength; i++) {
                arr.push({}) // 根据当前月份1号是星期几向往数组里添加空数据
            }
            let month = day.getMonth() + 1
            let daysLength = this.getMonthDaysLength(day, month) // 计算当前月份一共有多少天
            for (var i = 0; i < daysLength; i++) {
                let obj = {
                    date: new Date(day.setDate(i + 1)), // Date类型的日期数据
                    dateText: i + 1, // 用于显示的日期
                    fullday: day.getFullYear() + '-' + (day.getMonth() + 1).toString().padStart(2, '0') + '-' + day.getDate().toString().padStart(2, '0'),
                    chineseDateText: toLunar(day.getFullYear(), month, i + 1).day, // 农历日期
                    isToday: new Date().toDateString() === new Date(day.setDate(i + 1)).toDateString(), // 是否是今天
                    selected: new Date().toDateString() === new Date(day.setDate(i + 1)).toDateString() // 设置今天为选中状态
                }
                arr.push(obj)
            }
            return arr
        },
    },
};
</script>

<style scoped>
.day{
	color: #000;
	display: flex;
	flex-wrap: wrap;
}
.day_item{
	text-align: center;
	font-size: 24px;
	width: calc(100% / 7 - 20px);
	margin-bottom: 20px;
	position: relative;
	padding: 6px 0;
	margin: 10px;
	box-sizing: border-box;
	border: 1px solid #fff0;
	cursor: pointer;
}
.day_item_text{
	font-size: 14px;
	color: #999;
}
.day_item:hover,.day_item.active{
	box-shadow: 0 0 10px 0 #0000004f;
	border-radius: 8px;
	border: 1px solid var(--theme-color);
}
.day_item.active{
	background-color: var(--theme-color);
	color: #fff;
}
.day_item.active .day_item_text{color: #fff;}
.complete,.not_complete{
	position: absolute;
	right: 5px;
	bottom: 32px;
	font-size: 80px;
	line-height: 0;
	color: #b9b9b9;
}
.not_complete{color:#ffa51e}

.unselected{
    border: 1px solid #b9b9b9;
}
.selected{
    border: none;
    background-color: var(--theme-color1);
    box-shadow: 0 2px 6px 0 rgba(0,0,0,.1);
}


.calendar{
    min-width: 300px;
    max-width: 800px;
    padding: 10px 15px;
    background: #fff;
    border-radius: 10px;
}

.week-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    font-weight: bold;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
}

.week-wrapper .week-item {
    font-size: 14px;
    flex: 14.2857%;
    text-align: center;
}

.today-date-text {
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    line-height: 100%;
    padding: 0 20px;
}

.today-date-text .today-date {
    font-size: 18px;
    font-weight: bold;
}

.month-day-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-bottom: 1px solid #e5e5e5;
}

.day-item, .day-item-actived {
    flex: 14.2857%;
    padding: 10px 0;
    margin-bottom: 5px;
    font-size: 18px;
    cursor: pointer;
    overflow: hidden;
    font-weight: bold;
    text-align: center;
    color: #333;
}

.chinese-date-text{
    font-size: 14px;
    font-weight: normal;
    color: #999;
}

.day-item-actived {
    color: #fff;
    background: #409EFF;
    border-radius: 5px;
}

.day-item-actived .chinese-date-text{
    color: #fff;
}
</style>